// extracted by mini-css-extract-plugin
var _1 = "tsv0crX390L1YK4ZCWGz";
var _2 = "X9VdKZMx2mKaOMuzf9eY";
var _3 = "X9VdKZMx2mKaOMuzf9eY";
var _4 = "_yaTRr8VSmLCO6ptHjQI";
var _5 = "_yaTRr8VSmLCO6ptHjQI";
export { _1 as "pager", _2 as "pager-link", _3 as "pagerLink", _4 as "pagination-item", _5 as "paginationItem" }
